export default __webpack_public_path__ + "static/lineUpTitle-png-4343bfc3776c7722fb262f0dd737242a.png";